import { Link } from 'react-router-dom';
import React from 'react';
import { useTranslation } from '@/hooks';

export const LanguageSwitch = () => {
  const { language, switchLanguage } = useTranslation();

  const languageItemSettings: {
    [key: string]: { clickFunction: () => void; current: string; word: string };
  } = {
    de: {
      clickFunction: () => switchLanguage?.('en'),
      current: '(Deutsch)',
      word: 'English',
    },
    en: {
      clickFunction: () => switchLanguage?.('zh'),
      current: '(English)',
      word: '中文',
    },
    zh: {
      clickFunction: () => switchLanguage?.('de'),
      current: '(中文)',
      word: 'Deutsch',
    },
  };
  return (
    <Link
      to={'#'}
      onClick={() => languageItemSettings[language].clickFunction()}
    >
      {languageItemSettings[language].current}
      {' -> '}
      {languageItemSettings[language].word}
    </Link>
  );
};
